<div class="form-container">
  <alert></alert>
  <h2>Tag:
    @if (tag) {
      <span class="badge" [style.background-color]="tag.color" [style.color]="tagTextColor(tag.color)">{{ tag.name }}</span>
    } @else {
      {{ tagId }}
    }
  </h2>
  <div class="col-md-8 pl0">
    @if (project?.name) {
      <div class="row">
        <div class="col-md-3">Project</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{ project.name }}</div>
      </div>
    }
    @if (tag) {
      <div class="row">
        <div class="col-md-3">Colour</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{ tag.color }}</div>
      </div>
      <div class="row">
        <div class="col-md-3">Files</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{ tag.fileCount | number }}</div>
      </div>
    }
  </div>

  <h3 class="h5 mt-4">Files</h3>
  <table class="table table-bordered table-sm">
    <thead>
      <tr><th class="sort-na">File name</th><th class="sort-na">Path</th><th class="sort-na">Size (bytes)</th><th class="sort-na">Media</th></tr>
    </thead>
    <tbody>
      @if (loading) {
        <tr><td colspan="4" class="text-center">Loading...</td></tr>
      } @else {
        @for (file of files; track file.id) {
          <tr>
            <td>{{ file.fileName }}</td>
            <td>{{ file.filePath }}</td>
            <td>{{ sizeInBytes(file.size) }}</td>
            <td>{{ file.media }}</td>
          </tr>
        } @empty {
          <tr><td colspan="4" class="text-center">No files have this tag</td></tr>
        }
      }
    </tbody>
  </table>
  @if (count > limit) {
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item"><a class="page-link" [ngClass]="page === 1 ? 'disabled' : ''" href="javascript:;" (click)="paginate(-1)">Previous</a></li>
        <li class="page-item"><a class="page-link text" href="javascript:;">Page {{ page }} of {{ pages }}</a></li>
        <li class="page-item"><a class="page-link" [ngClass]="page === pages ? 'disabled' : ''" href="javascript:;" (click)="paginate(1)">Next</a></li>
      </ul>
    </nav>
  }

  <div class="row footer">
    <a [routerLink]="['/dashboard/project', projectId, 'tags']" [state]="{ data: { project: project } }" class="btn btn-sm btn-primary">Back to Tags</a>
  </div>
</div>
